<div class="form__input-group-prepend" *ngIf="prepend" [class.required]="invalid && touched" [class.readonly]="readonly">{{prepend}}</div>
<input [type]="type"
       [attr.id]="id"
       [(ngModel)]="value"
       (change)="internalOnChange($event)"
       (input)="internalOnChange($event)"
       (keyup)="internalKeyUp($event)"
       (keydown)="internalKeyDown($event)"
       [class.required]="(invalid && touched) || (invalid && value)"
       class="{{this.cssClasses}}"
       [attr.tabindex]="tabIndex != null ? tabIndex : null"
       [attr.inputmode]="inputmode"
       [placeholder]="placeholder ?? ''"
       [class.hasAppend]="append.children.length > 0"
       [class.form__input--small]="small"
       #textbox
/>

<div #append class="form__input-group-append" [class.required]="(invalid && touched) || (invalid && value)" [class.readonly]="readonly" [hidden]="append.innerHTML.length === 0">
    <ng-content select="[append]"></ng-content>
</div>

<p *ngIf="((invalid && touched) || (invalid && value)) && !isInputFocused && invalidMessage.length"
   class="u-text-color--pink u-text--small u-margin-bottom--none">
    {{ invalidMessage }}
</p>
